import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { SDKPostSignUpContext } from '@bingads-webui-campaign-react/sdk-post-signup-context';
import { withSiteMap, processorSet, processor } from '@bingads-webui-react/with-site-map';
import { useBackToOverview } from './use-back-to-overview';
import { SDKPageNavigationHeader } from './navigation-header';
import { SDKSettingsForm } from './sdk-settings-form';

const getStyles = () => ({
  sdkSettingsPage: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  sdkSettingsFormWrapper: {
    flex: 1,
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
    margin: '24px 43px 27px 43px',
    boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.12), 0px 2px 4px 0px rgba(0, 0, 0, 0.14)',
    border: '1px solid transparent',
    '& .react-block-ui, & .react-block-ui-none': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
    },
  },
  sdkSettingsForm: {
    flex: 1,
    display: 'flex',
    overflow: 'hidden',
    borderRadius: 4,
    background: '#f9f9f9',
    padding: '24px 32px 24px 32px',
  },
  '@global': {
    '& .fui-FluentProvider': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
});

const SDKSettingsPageInternal = React.memo(({
  siteMap,
  title,
  className,
  formProps,
}) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);
  const { backToOverviewPage } = useBackToOverview({ siteMap });

  return (
    <div className={classNames(classes.sdkSettingsPage, className)}>
      <SDKPageNavigationHeader title={i18n.getString(title)} onClickBackButton={backToOverviewPage} />
      <SDKPostSignUpContext>
        <SDKSettingsForm
          {...formProps}
        />
      </SDKPostSignUpContext>
    </div>
  );
});

SDKSettingsPageInternal.propTypes = {
  siteMap: PropTypes.shape({}).isRequired,
  view: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  formProps: PropTypes.shape({
    id: PropTypes.string.isRequired,
    ContentComponent: PropTypes.func.isRequired,
    repository: PropTypes.func.isRequired,
  }).isRequired,
};

SDKSettingsPageInternal.defaultProps = {
  className: '',
};

export const SDKSettingsPage = withSiteMap(SDKSettingsPageInternal, [processor.processPath, ...processorSet.basic]);
